module.exports = __webpack_public_path__ + "static/img/developmentHistory_en.a133cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/developmentHistory_en.png
// module id = WLXV
// module chunks = 1